import {Fragment, useEffect, useState} from 'react';

const Header: (props: any) => JSX.Element = (props: any) => {

    const [toggled, setToggled] = useState<boolean>(true);
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);
    const {setAside} = props;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (isMobile) {
            setToggled(true);
        } else {
            setToggled(false);
        }
    }, [isMobile]);

    return (
        <Fragment>
            <div className="grid grid-cols-2 bg-pomegranate-600 text-[18px]">
                <div className="flex lg:ps-[60px]">
                    <div className="lg:hidden flex flex-col gap-2 w-[35px] mt-[33px] ms-[24px] relative" onClick={() => setToggled(!toggled)} >
                        <div className={`flex w-full h-[3px] bg-white transition-all absolute${toggled ? '' : ' rotate-45 mt-[10px]'}`} />
                        <div className={`flex w-full h-[3px] bg-white transition-all absolute${toggled ? ' opacity-100 mt-2' : ' opacity-0'}`} />
                        <div className={`flex w-full h-[3px] bg-white transition-all absolute${toggled ? ' mt-4' : ' rotate-[-45deg] mt-[10px]'}`} />
                    </div>
                    {!toggled &&
                        <nav className="flex flex-col absolute bg-pomegranate-600 z-[1024] w-full py-5 mt-[92px] lg:mt-0 lg:py-0 lg:w-auto lg:bg-none lg:relative lg:flex-row gap-6 text-white items-center">
                            <button className="uppercase transition-all opacity-50 hover:opacity-100" onClick={() => setAside(true)}>So funktionierts</button>
                            <a href="https://www.die-gschwinden.at/betko" target="_blank" className="uppercase transition-all opacity-50 hover:opacity-100">Über uns</a>
                            <a href="https://www.die-gschwinden.at/neuigkeiten" target="_blank" className="uppercase transition-all opacity-50 hover:opacity-100">Blog</a>
                            <a href="tel:+43318537750" className="uppercase transition-all opacity-50 hover:opacity-100">+43 3185 37750</a>
                        </nav>
                    }
                </div>
                <div className="flex justify-end">
                    <div className="flex flex-row">
                        <div className="bg-pomegranate-800 w-[20px] skew-x-[-12deg]" />
                        <div className="bg-pomegranate-950 text-white uppercase font-semibold p-8 px-10 ps-[60px] pe-20 me-[-20px] skew-x-[-12deg]">
                            <div className="skew-x-[12deg] font-bold">Konfigurator</div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Header;
